import type { ArchiveLocationClientDto, UpdateArchiveLocationDto, CreateArchiveLocationDto, DeleteArchiveLocationDto } from '@mimir/common/dto/archiveLocationDto';
import { apiPut, apiDelete, apiPost, apiGet } from '@mimir/common/util/http';
import * as Path from '../aws/api/path';
import type { BackendClient } from '@mimir/common/util/backendClient';
import { assumeResultObject, assumeResultArray, assumeResultObjectOrNull } from '@mimir/common/client/assumeResult';

export const api_getTenantConfigDefaultArchiveLocation = async (c: BackendClient): Promise<ArchiveLocationClientDto | null> =>
  apiGet(c.getApiClient(), Path.ofTenantConfigDefaultArchiveLocation(c.getServiceLinks())).then(result => assumeResultObjectOrNull<ArchiveLocationClientDto>(result, 'areCredentialsSaved'));


export const api_deleteTenantConfigDefaultArchiveLocation = async (c: BackendClient) =>
  apiDelete(c.getApiClient(), Path.ofTenantConfigDefaultArchiveLocation(c.getServiceLinks()));


export const api_getTenantConfigArchiveLocations = async (c: BackendClient): Promise<(ArchiveLocationClientDto)[]> =>
  apiGet(c.getApiClient(), Path.ofTenantConfigArchiveLocations(c.getServiceLinks())).then(result => assumeResultArray<ArchiveLocationClientDto>(result));

export const api_createTenantConfigArchiveLocation = async (c: BackendClient, archiveLocation: CreateArchiveLocationDto): Promise<ArchiveLocationClientDto> =>
  apiPut(c.getApiClient(), Path.ofTenantConfigArchiveLocations(c.getServiceLinks()), archiveLocation).then(result => assumeResultObject<ArchiveLocationClientDto>(result, 'name'));

export const api_updateTenantConfigArchiveLocation = async (c: BackendClient, archiveLocation: UpdateArchiveLocationDto): Promise<(ArchiveLocationClientDto)> =>
  apiPost(c.getApiClient(), Path.ofTenantConfigArchiveLocations(c.getServiceLinks()), archiveLocation).then(result => assumeResultObject<ArchiveLocationClientDto>(result, 'id'));

export const api_deleteTenantConfigArchiveLocation = async (c: BackendClient, archiveLocation: DeleteArchiveLocationDto) =>
  apiDelete(c.getApiClient(), Path.ofTenantConfigArchiveLocations(c.getServiceLinks()), archiveLocation);

